/*

Utilities for optional functions.

*/

var $ = require('jquery');
var jQuery = $;

//-----------------------------
// Object and Array Helpers
//-----------------------------

module.exports.cloneArray = function(array){
  return array.slice(0);
}

module.exports.clone = function(obj){
  return JSON.parse(JSON.stringify(obj));
}

var href_replace = function(str, find, replace){

  //Replace all occurrences of this link prefix
  var str = str.replace(new RegExp('href="'+find, 'g'), 'href="'+replace);

  //Replace all the ones with single quotes in Vue template inline JS
  var str = str.replace(new RegExp('href="\''+find, 'g'), 'href="\''+replace);

  return str;

}

//-----------------------------
// Link Fixers
//-----------------------------

module.exports.fixLinks = function(html){

  // console.log(html);

  //If not enabled, then return HTML unedited
  if(!Creek.data.router.enable){
    return html;
  }

  for(find in Creek.data.router.linkReplacements){
    html = href_replace(html, find, Creek.data.router.linkReplacements[find]);
  }

  return html;

}

module.exports.getURLHost = function(url){
  var tmp = document.createElement('a');
  tmp.href = url;
  return tmp.hostname;
}

//-------------------------------
// Cookies
//-------------------------------

module.exports.cookies = {};

module.exports.cookies.create = function(name,value,seconds) {
  if (seconds) {
    var date = new Date();
    date.setTime(date.getTime()+(seconds));
    var expires = "; expires="+date.toGMTString();
  }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/";
};

module.exports.cookies.read = function(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
};

module.exports.cookies.delete = function(name) {
  Cookies.create(name,"",-1);
};


//-------------------------------
// Images
//-------------------------------

//Images
module.exports.images = {

  imageExists: function(image_url){

    var http = new XMLHttpRequest();

    http.open('HEAD', image_url, false);
    http.send();

    return http.status != 404;

  }

}

module.exports.capitalizeFirstLetter = function(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}


//-------------------------------
// Browser Detection Helpers
//-------------------------------

/*
TODO:
- Use feature detection instead of browser checks.
- But first, figure out what features are needed
*/

module.exports.browserChecks = {

  chrome: function(){

    var isChromium = window.chrome,
        winNav = window.navigator,
        vendorName = winNav.vendor,
        isOpera = winNav.userAgent.indexOf("OPR") > -1,
        isIEedge = winNav.userAgent.indexOf("Edge") > -1,
        isIOSChrome = winNav.userAgent.match("CriOS");

    var itsChrome = false;

    // is Google Chrome on IOS
    if(isIOSChrome){
      itsChrome = true;
    }
    // is Google Chrome
    else if(isChromium !== null && isChromium !== undefined && vendorName === "Google Inc." && isOpera == false && isIEedge == false) {
      itsChrome = true;
    }
    // not Google Chrome
    else {
      itsChrome = false;
    }

    return itsChrome;

  },

  firefox: function(){
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  },

  safari: function() {

    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
      return true;
    }
    else{
      return false;
    }

  },

  internetExplorer: function() {

    var ua = window.navigator.userAgent;

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      var rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    // other browser
    return false;

  },

  edge: function() {

    var ua = window.navigator.userAgent;

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;

  },

  opera: function() {

    return navigator.userAgent.match(/Opera|OPR\//) ? true : false;

  },

  facebook: function() {
    var ua = navigator.userAgent || navigator.vendor || window.opera;
    var isFacebook = (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
    return isFacebook;
  }

};


//-------------------------------
// Dynamic JS + CSS File Loading
//-------------------------------

module.exports.loadScript = function(src, callback, appendTo)
{
  appendTo = appendTo || false;
  callback = callback || function(){};
  var el,
      r,
      t;
  r = false;
  el = document.createElement('script');
  el.type = 'text/javascript';
  el.src = src;
  el.onload = el.onreadystatechange = function() {
    //console.log( this.readyState ); //uncomment this line to see which ready states are called.
    if ( !r && (!this.readyState || this.readyState == 'complete') )
    {
      r = true;
      callback();
    }
  };

  if(appendTo){
    $(el).appendTo(appendTo);
  }
  else{
    t = document.getElementsByTagName('link')[0];
    t.parentNode.insertBefore(el, t);
  }

}

//Loads a CSS file with JavaScript
module.exports.loadCSS = function(href, callback, appendTo)
{
  appendTo = appendTo || false;
  callback = callback || function(){};
  var el,
      r,
      t;
  r = false;
  el = document.createElement('link');
  el.href = href;
  el.onload = el.onreadystatechange = function() {
    //console.log( this.readyState ); //uncomment this line to see which ready states are called.
    if ( !r && (!this.readyState || this.readyState == 'complete') )
    {
      r = true;
      callback();
    }
  };

  if(appendTo){
    $(el).appendTo(appendTo);
  }
  else{
    t = document.getElementsByTagName('link')[0];
    t.parentNode.insertBefore(el, t);
  }

}

//-------------------------------
// Google Analytics
//-------------------------------

// Safe Google Analytics Shim
module.exports.ga = function(action, type, eventCategory, eventAction, eventLabel, eventValue, fieldsObject){

  fieldsObject = fieldsObject || null;

  if (typeof ga != 'undefined') {
    ga(action, type, eventCategory, eventAction, eventLabel, eventValue, fieldsObject);
  }

}

// Alias of GA Shim (above)
module.exports.GoogleAnalytics = module.exports.ga;



// WEBPACK FOOTER //
// ./src/creek-util.js